// extracted by mini-css-extract-plugin
export default {"item":"YGX57VxkmQMloHA11Jqz","attribute":"e9IXxX0BoQczXagKRzUg","level":"d9lgp1t74VjvcMUNEz7k","nota":"em5bJ59mMRgTgCW30X_K"};